import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { CatalogContainer } from './containers/catalog-container'
import { ProductPageContainer } from './containers/product-page-container/product-page-container';

import { AuthGuard } from '../auth/services/auth-guard-service'
import { SalesRepGuard } from '../auth/services/sales-rep-guard-service';

const routes: Routes = [
  {
    path: 'catalog',
    canActivate: [AuthGuard, SalesRepGuard],
    children: [
      {
        path: '**',
        component: CatalogContainer
      }
    ]
  },
  {
    path: 'favorites',
    canActivate: [AuthGuard, SalesRepGuard],
    children: [
      {
        path: '**',
        component: CatalogContainer
      }
    ]
  },
  {
    path: 'search/:term',
    canActivate: [AuthGuard, SalesRepGuard],
    children: [
      {
        path: '**',
        component: CatalogContainer
      }
    ]
  },
  {
    path: 'product/:id',
    canActivate: [AuthGuard, SalesRepGuard],
    children: [
      {
        path: '**',
        component: ProductPageContainer
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class CatalogRoutingModule { }
